import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-login-as',
  templateUrl: './login-as.component.html',
  styleUrls: ['./login-as.component.scss']
})
export class LoginAsComponent implements OnInit {

    public show: boolean = false;
    public loginForm: FormGroup;
    public errorMessage: any;

    showLogin: boolean = true;
    
    userName: string = "";
    password: string = "";
    user_userName: string = "";

    btnDisabled = false;

    loginData: any = {
        userName: "",
        password: "",
        user_userName: ""
    }

    myControl = new FormControl();
    
    constructor(public authenticationService: AuthenticationService,
        private common: CommonService,
        private _activatedRoute: ActivatedRoute,
        private router: Router) {

        let authorizationData: any = this.authenticationService._getLocalStorage("authorizationData");
        if (authorizationData != null) {
            if (authorizationData.isAuth) {
                var returnUrl = this._activatedRoute.snapshot.queryParams['returnUrl'] || '/';
                if (returnUrl != "/")
                    this.router.navigate([returnUrl]);
                else {
                    this.router.navigate(['/home/news-feed']);
                    //this.router.navigate(['/dashboard/default']);
                }
            }
        }
    }

    ngOnInit() {
    }

    

    getUserIpLocation() {
        this.authenticationService.getUserIpLocation().subscribe(
            (res: any) => {
                //TODO: Check the output of the service - the below line
                //this.rootScope.userAddress = res;
                console.log(res);
            },
            (err: any) => {
                console.error("getUserIpLocation", err);
            })
    }


    userId: string;
    
    
    login(userData: any) {

        //generate token

        let authorizationData: any = {
            id: userData.id,
            token: '',
            userName: userData.eMail,
            refreshToken: "",
            useRefreshTokens: false,
            isAuth: true,
            mobileNumber: userData.mobilePhone,
             
        };

        this.authenticationService._setLocalStorage("authorizationUserData", JSON.stringify(userData));
        this.authenticationService._setLocalStorage("authorizationData", JSON.stringify(authorizationData));
        this.authenticationService._authentication = authorizationData;
        this.authenticationService.userData = userData;

        //TODO: Pass the user ID
        //this.authenticationService._addUserLogin();

        this.getUserIpLocation();

        var returnUrl = this._activatedRoute.snapshot.queryParams['returnUrl'] || '/';
        if (returnUrl != "/")
            this.router.navigate([returnUrl]);
        else {

            this.router.navigate(['/home/news-feed']);
            //this.router.navigate(['/articles/all']);
        }

    }

    loginAs() {
        if (this.userName === '' || this.password === '' || this.user_userName === '') {
            this.btnDisabled = false;
            this.common.ShowMessage('error', 'Please type your email, password and user email address!', "");
        }
        else {
            this.btnDisabled = true;
            this.loginData = {
                userName: this.userName,
                password: this.password,
                user_userName : this.user_userName
            };

            this.loginData.password = this.loginData.password.replace("#", "(*%23*)").replace("?", "(*%3F*)");

            this.authenticationService._loginAs(this.loginData).subscribe(
                (userData: any) => {
                    if (userData.isError) {
                        this.common.ShowMessage('error', userData.errorMessage, "");
                        this.btnDisabled = false;
                    }
                    else {
                        if (userData.isAuthenticated) {

                            let authorizationData: any = {
                                id: userData['loginAsUserData'].id,
                                token: userData['token'],
                                userName: this.loginData.user_userName,
                                refreshToken: "",
                                useRefreshTokens: false,
                                isAuth: true,
                                isLoginAs: true,
                                requesterLoginAsUser: userData['userData']
                            };

                            this.authenticationService._setLocalStorage("authorizationUserData", JSON.stringify(userData['loginAsUserData']));
                            this.authenticationService._setLocalStorage("authorizationData", JSON.stringify(authorizationData));
                            this.authenticationService._authentication = authorizationData;
                            this.authenticationService.userData = userData['loginAsUserData'];

                            //TODO: Pass the user ID
                            this.authenticationService._addUserLogin();

                            this.getUserIpLocation();

                            var returnUrl = this._activatedRoute.snapshot.queryParams['returnUrl'] || '/';
                            if (returnUrl != "/")
                                this.router.navigate([returnUrl]);
                            else {
                                this.router.navigate(['/home/news-feed']);
                            }

                        }
                        else {
                            this.btnDisabled = false;
                            this.common.ShowMessage('error', 'Incorrect Email Address or Password', "");
                        }
                    }




                    
                },
                (userDataError: any) => {
                    this.btnDisabled = false;
                    let error: any = userDataError;
                    console.error("userDataError", error);
                    this.common.ShowMessage('error', "Failed to login. Check with mygistec administrator", "")
                    // this.toastr.error(error['error_description'], 'Oops!');
                }
            );
        }
    }

}